<template>
  <div class="robotTelephoneInfo">
    <div class="searchCondition">
      <div class="searchConditionItem">
        手机号：
        <el-input
          v-model="queryParams.phone"
          placeholder="请输入电话号码"
          style="width: 300px; margin-right: 10px"
          clearable
          @keyup.enter.native="handleSearch"
        />
      </div>
      <div class="searchConditionItem">
        时间：
        <el-date-picker
          class="startTime"
          v-model="queryParams.startTime"
          type="datetime"
          placeholder="起始时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
        ></el-date-picker>
        &nbsp;-&nbsp;
        <el-date-picker
          class="endTime"
          v-model="queryParams.endTime"
          type="datetime"
          placeholder="终止时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>
      <div class="searchButton">
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      border
      v-loading="loading"
    >
      <el-table-column prop="id" label="id" width="150" align="center" />
      <el-table-column
        prop="phone"
        label="电话号码"
        min-width="150"
        align="left"
      />
      <el-table-column
        prop="callDuration"
        label="通话时间"
        min-width="150"
        align="left"
      >
        <template slot-scope="scope">
          {{ $common.timeConsuming(scope.row.callDuration / 1000) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="startTime"
        label="开始时间"
        min-width="150"
        align="left"
      />
      <el-table-column
        prop
        label="操作"
        width="100"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="playCallRecord(scope.row)"
            :disabled="!scope.row.recordUrl"
            >播放录音</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div
      style="
        margin-top: 15px;
        display: flex;
        justify-content: right;
        align-items: center;
      "
    >
      <div>
        <el-select
          v-model="queryParams.pageSize"
          @change="handlePageSizeChange"
          style="width: 100px; margin: 0 10px"
        >
          <el-option label="10条/页" :value="10"></el-option>
          <el-option label="20条/页" :value="20"></el-option>
          <el-option label="50条/页" :value="50"></el-option>
          <el-option label="100条/页" :value="100"></el-option>
        </el-select>
      </div>
      <div>
        <el-button
          :disabled="pageNo == 1"
          @click="handlePrev"
          icon="el-icon-arrow-left"
          >上一页</el-button
        >
        <el-button :disabled="disabledNext" @click="handleNext"
          >下一页<i class="el-icon-arrow-right el-icon--right"></i
        ></el-button>
      </div>
    </div>

    <!-- 播放录音 -->
    <el-dialog
      class="customDialog"
      :visible.sync="playCallRecordShow"
      width="350px"
      @close="closeCallDialog"
    >
      <audio
        ref="audioCall"
        :src="currentCallSrc"
        autoplay="autoplay"
        controlsList="nodownload"
        controls="controls"
      ></audio>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "robotTelephoneInfo",
  data() {
    return {
      loading: false,
      tableData: [],
      queryParams: {
        phone: "",
        startTime: moment().subtract(5, 'minutes').format("YYYY-MM-DD HH:mm:ss"),
        endTime: moment().format("YYYY-MM-DD HH:mm:ss"),
        pageSize: 10,
        direction: "NEXT",
        id: 0,
      },
      // 用于存储当前页的最大和最小 id，用于翻页
      minId: null,
      maxId: null,
      playCallRecordShow: false,
      currentCallSrc: "",
      playCallFlag: true,
      pageNo: 1,
      pickerOptions: {
        disabledDate(time) {
          const start = new Date();
          start.setHours(23);
          start.setMinutes(59);
          start.setSeconds(59);
          start.setMilliseconds(59);
          return time.getTime() > start;
        },
      },
    };
  },
  computed: {
    disabledNext() {
      return this.tableData.length < this.queryParams.pageSize;
    },
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    // 查询列表
    fetchList() {
      this.loading = true;
      let params = {
        ...this.queryParams
      };

      this.$http("/robotTel/list", null, "get", null, params)
        .then((res) => {
          this.loading = false;
          if (res.result === 200) {
            this.tableData = res.data.list;

            // 更新最大和最小 id
            if (this.tableData.length > 0) {
              const ids = this.tableData.map((item) => item.id);
              const currentMinId = Math.min(...ids);
              const currentMaxId = Math.max(...ids);

              this.minId = currentMinId;
              this.maxId = currentMaxId;
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("查询失败");
        });
    },
    // 查询按钮
    handleSearch() {
      this.queryParams.pageSize = 10;
      this.handlePageSizeChange();
    },
    // 上一页
    handlePrev() {
      this.queryParams.direction = "PREV";
      this.queryParams.id = this.minId;
      this.pageNo--;
      this.fetchList();
    },
    // 下一页
    handleNext() {
      this.queryParams.direction = "NEXT";
      this.queryParams.id = this.maxId;
      this.pageNo++;
      this.fetchList();
    },
    // 改变每页显示条数
    handlePageSizeChange() {
      // 重置到第一页
      this.queryParams.direction = "NEXT";
      this.queryParams.id = 0;
      this.minId = null;
      this.maxId = null;
      this.pageNo = 1;
      this.fetchList();
    },
    playCallRecord(val) {
      //播放录音
      this.playCallRecordShow = true;
      this.currentCallSrc = val.recordUrl;
      if (this.playCallFlag == false) {
        this.$refs.audioCall.play();
        this.playCallFlag = true;
      }
    },
    closeCallDialog() {
      //播放录音关闭
      this.$refs.audioCall.pause();
      this.playCallFlag = false;
    },
  },
};
</script>

<style scoped>
.robotTelephoneInfo {
  position: relative;
}
.tableClass {
  padding: 20px;
}
</style>
